import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RoleCard } from 'widgets/roles-info/ui/RoleCard/RoleCard';

import { ModalRolesCardsStyled } from './ModalRolesCards.styles';

export const ModalRolesCards: FC = () => {
	const { t } = useTranslation();

	return (
		<ModalRolesCardsStyled>
			<RoleCard
				inModal
				heading={t(`Marketplace_Department_Administrator`)}
				subheading={t(`Marketplace_All_Management`)}
				features={[
					t(`Marketplace_App_Connection_and_Usage`),
					t(`Marketplace_Subscription_for_App`),
					t(`Marketplace_Subscription_Management`),
					t(`Marketplace_Invoice_Tracking`),
				]}
			/>
			<RoleCard
				inModal
				heading={t(`Marketplace_Office_Manager`)}
				subheading={t(`Marketplace_Usage_Only`)}
				features={[
					t(`Marketplace_Free_App_Connection_and_Usage`),
					t(`Marketplace_App_Connection_and_Usage_with_Paid_Subscription_by_Administrator_Subdivision`),
					t(`Marketplace_View_Subscription_Status`),
				]}
			/>
		</ModalRolesCardsStyled>
	);
};
